import { useParams } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { ColorRing } from 'react-loader-spinner';

import { setCurrentTrapTable } from './Slice/trapSlice';
import TablesTitle from './TablesTitle/TablesTitle';

import { useAppDispatch, useAppSelector } from 'slices';
import MultiCatchMouseTrapsTable from 'components/TrapsTables/MultiCatchMouseTraps/MultiCatchMouseTrapsTable';
import ClawingInsectsTable from 'components/TrapsTables/CrawlingInsectsTraps/ClawingInsectsTable';
import FeromonsInsectsTable from 'components/TrapsTables/FeromonTraps/FeromonInsectsTable';
import BsTrapsTable from 'components/TrapsTables/BsTraps/BsTrapTable';
import QRCodeModal from 'components/QRCodeModal/QRCodeModal';
import SRBMTrapsTable from 'components/TrapsTables/SRBMTraps/SRBMTrapTable';
import HubsTable from 'components/TrapsTables/Hubs/HubsTable';
import STRTrapsTable from 'components/TrapsTables/SnapTrapTables/SRSTTraps/SRSTTrapsTable';
import STMTrapsTable from 'components/TrapsTables/SnapTrapTables/SMSTTraps/SMSTTrapsTable';
import { TrapTableType } from 'components/TrapsTables/trapTables';
import useGetObjectTraps from 'hooks/Analitics/ObjectTraps/useGetObjectTraps';

const Traps: React.FC = () => {
  const { slug } = useParams();
  const dispatch = useAppDispatch();

  const { data: objectTraps, refetch, isFetching } = useGetObjectTraps(slug!, !!slug);
  const currentTable = useAppSelector(state => state.Traps.currentTrapTable);
  const slugTable = useAppSelector(state => state.Traps.slug);
  const lastProcessedDataRef = useRef<any>(null);
  useEffect(() => {
    if (isFetching || !objectTraps || !slug) return;

    if (slugTable === slug) {
      lastProcessedDataRef.current = objectTraps;
      return;
    }

    if (lastProcessedDataRef.current === objectTraps) return;

    let defaultTable = TrapTableType.Hubs;

    if (objectTraps.mct?.installed_now) {
      defaultTable = TrapTableType.MultiCatchMouseTraps;
    } else if (objectTraps.srbm?.installed_now) {
      defaultTable = TrapTableType.SmartRodenBaitModule;
    } else if (objectTraps.smst?.installed_now) {
      defaultTable = TrapTableType.SnapTrapMouse;
    } else if (objectTraps.srst?.installed_now) {
      defaultTable = TrapTableType.SnapTrapRat;
    }

    dispatch(setCurrentTrapTable({ traps: defaultTable, slug }));
    lastProcessedDataRef.current = objectTraps;
  }, [objectTraps, isFetching, slug, dispatch, slugTable]);

  useEffect(() => {
    if (!slug) return;
    refetch();
  }, [slug, refetch]);

  if (isFetching) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '350px' }}>
        <ColorRing
          visible
          height="80"
          width="80"
          ariaLabel="color-ring-loading"
          wrapperStyle={{}}
          wrapperClass="color-ring-wrapper"
          colors={['#9C7AE2', '#E27A8C', '#C0E27A', '#7AE2D0', '#F7F18F']}
        />
      </div>
    );
  }

  return (
    <div>
      <TablesTitle slug={slug || ''} />
      <div hidden={currentTable !== TrapTableType.MultiCatchMouseTraps}>
        {currentTable === TrapTableType.MultiCatchMouseTraps && <MultiCatchMouseTrapsTable slug={slug || ''} />}
      </div>
      <div hidden={currentTable !== TrapTableType.SmartRodenBaitModule}>
        {currentTable === TrapTableType.SmartRodenBaitModule && <SRBMTrapsTable slug={slug || ''} />}
      </div>
      <div hidden={currentTable !== TrapTableType.SnapTrapMouse}>
        {currentTable === TrapTableType.SnapTrapMouse && <STMTrapsTable slug={slug || ''} />}
      </div>
      <div hidden={currentTable !== TrapTableType.SnapTrapRat}>
        {currentTable === TrapTableType.SnapTrapRat && <STRTrapsTable slug={slug || ''} />}
      </div>
      <div hidden={currentTable !== TrapTableType.BaitStations}>
        {currentTable === TrapTableType.BaitStations && <BsTrapsTable slug={slug || ''} />}
      </div>
      <div hidden={currentTable !== TrapTableType.CrawlingInsectsTrap}>
        {currentTable === TrapTableType.CrawlingInsectsTrap && <ClawingInsectsTable slug={slug || ''} />}
      </div>
      <div hidden={currentTable !== TrapTableType.FeromonTraps}>
        {currentTable === TrapTableType.FeromonTraps && <FeromonsInsectsTable slug={slug || ''} />}
      </div>
      <div hidden={currentTable !== TrapTableType.Hubs}>
        {currentTable === TrapTableType.Hubs && <HubsTable slug={slug || ''} />}
      </div>
      <QRCodeModal />
    </div>
  );
};

export default Traps;
